import { render, staticRenderFns } from "./UploadJsonPopup.vue?vue&type=template&id=85ab8450&"
import script from "./UploadJsonPopup.vue?vue&type=script&lang=js&"
export * from "./UploadJsonPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports